// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ebf85214","703":"6720d427","787":"3a48d566"}[chunkId] + ".chunk.js";
};